"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleReservationType = void 0;
var VehicleReservationType;
(function (VehicleReservationType) {
    VehicleReservationType["RESERVED"] = "RESERVED";
    VehicleReservationType["PARTIAL_REQUEST"] = "PARTIAL_REQUEST"; // Multiple leads can request same vehicle
})(VehicleReservationType = exports.VehicleReservationType || (exports.VehicleReservationType = {}));
